import { gql } from '@apollo/client';

export const ALL_INSTITUTION_ACTIVITIES = gql`
  query AllInstitutionActivities($input: ExportArgs) {
    activities: allInstitutionActivities(input: $input) {
      id
      name
      description
    }
  }
`;
